import React from 'react';

import { InfoCircleOutlined as InfoOutlined } from '@ant-design/icons';

const Atention = () => {
  return (
    <div className='flex items-center justify-start gap-3 bg-[#f5f5f5] p-[10px] text-[0.875rem]'>
      <InfoOutlined size={32} />
      <p className='m-0! text-black'>
        Atenção: Em páginas de vendas que são abertas a partir de APP&apos;s de redes sociais, links com o atributo html
        target=&quot;blank&quot; podem não funcionar. Recomendamos que o atributo não seja utilizado.
      </p>
    </div>
  );
};

export default Atention;
